import { render, staticRenderFns } from "./detail.html?vue&type=template&id=bd6fd3d6&scoped=true&"
import script from "./DetailNews.vue?vue&type=script&lang=js&"
export * from "./DetailNews.vue?vue&type=script&lang=js&"
import style0 from "./DetailNews.vue?vue&type=style&index=0&id=bd6fd3d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6fd3d6",
  null
  
)

export default component.exports